export default function($) {
  const productsSwiper = new Swiper('.js-products-slider', {
    autoplay: 3000,
    speed: 750,
    autoplay: {
      enabled: false,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    loop: true,
    slidesPerView: 1,
    spaceBetween: 2,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      enabled: true,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640:{
        slidesPerView: 1.4,
        spaceBetween: 5,
      },
      960:{
        slidesPerView: 1.4,
        spaceBetween:0,
      }
    },
  });

  const homeSwiper = new Swiper('.js-home-slider', {
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      enabled: true,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const variationsSwiper = new Swiper('.js-product-variations-slider', {
    loop: true,
    slidesPerView: 1,
    navigation: {
      enabled: true,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Récupérer tous les liens des variations
  const variationLinks = document.querySelectorAll('.js-swiper-product-variation');

  // Ajouter la classe active au premier élément par défaut
  if (variationLinks.length > 0) {
    variationLinks[0].classList.add('active');
  }

  // Ajouter un écouteur d'événement pour chaque lien
  variationLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault(); // Empêcher le comportement par défaut du lien

      // Enlever la classe active de tous les liens
      variationLinks.forEach(item => {
        item.classList.remove('active');
      });

      // Ajouter la classe active à l'élément cliqué
      this.classList.add('active');

      // Récupérer l'index de la diapositive à afficher
      const slideIndex = parseInt(this.getAttribute('data-slide-index'));

      // Déplacer le slider vers cette diapositive
      variationsSwiper.slideTo(slideIndex);
    });
  });

  // Mettre à jour la classe active lorsque le slider change (optionnel)
  variationsSwiper.on('slideChange', function() {
    // Enlever la classe active de tous les liens
    variationLinks.forEach(item => {
      item.classList.remove('active');
    });

    // Ajouter la classe active au lien correspondant à la diapositive actuelle
    const activeIndex = variationsSwiper.realIndex; // realIndex pour les sliders avec loop:true
    if (variationLinks[activeIndex]) {
      variationLinks[activeIndex].classList.add('active');
    }
  });
}
